
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { Options, Vue } from "vue-class-component"; //基本需要\
import { store } from "@/store"; //引入仓库
import * as echarts from "echarts";
import {
  dispatchGetXhookReportList,
  dispatchGetXhookReport,
  dispatchSendXhookReport,
  dispatchDeleteXhookReport,
} from "@/store/performance/actions";
import {
  readXhookReportList,
  readXhookReport,
} from "@/store/performance/getters";
import { readUserProfile } from "@/store/main/getters";
import { getLocalProject, isJsonString, unique_json, unique } from "@/utils";
import { dispatchGetProjectUsers } from "@/store/project/actions";
import {
  readProjectDetail,
  readProjectUsers,
  readMyProjects,
} from "@/store/project/getters";
import { ElMessage } from "element-plus";
@Options({
  components: {
    SideMenu,
  },
})
export default class Xhook extends Vue {
  public com_risk = "低风险";
  public core_data: any[] = [];
  public report_id = 0;
  public resBase64: any[] = [];
  public loading = false;
  public localProject = Number(getLocalProject());
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public test_info = {
    cur_version: "1.0.30.13433",
    test_time: "2022/01/10",
    month: "2022.01",
    old_version: "1.0.29.13318",
    old_month: "2022.01",
    type: 0,
  };
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  // 删除报告
  public async handleDelete() {
    this.loading = true;
    this.resBase64 = [];
    await dispatchDeleteXhookReport(store, {
      id: this.report_id,
      project: this.localProject,
    });
    this.report_id = this.xhook_reports[0]?.id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    await dispatchGetXhookReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    this.set_report();
    this.get_risk();
    await this.drawline();
    for (let i in this.memory_trend.memory) {
      await this.drawEachMemory(i, this.memory_trend.memory[i]);
    }
    this.loading = false;
  }
  public sendOut() {
    this.edit = !this.edit;
  }
  public get xhook_reports() {
    return readXhookReportList(store);
  }
  public memoryList = ["BR_初始化", "HALL_初始化", "MP_初始化"];
  // 总内存趋势图
  public total_trend = {
    x_axis: ["1.0.30.13433"],
    scene_list: ["hall", "mp", "br"],
    mono: {
      hall: [145710],
      mp: [143410],
      br: [145410],
    },
    engine: {
      hall: [14510],
      mp: [145410],
      br: [145410],
    },
    total: {
      BR_初始化: [],
      HALL_初始化: [290832, 290821],
      MP_初始化: [],
    },
  };
  // 各内存趋势图
  public memory_data = {
    br: {
      all: [],
      libunity: [],
    },
    hall: {
      all: [],
      libunity: [],
    },
    mp: {
      all: [],
      libunity: [],
    },
  };
  public memory_trend = {
    x_axis: [],
    memory: { BR_初始化: [], HALL_初始化: [290832, 290821], MP_初始化: [] },
  };
  public previous_version = "--";

  // 解析报告邮件人
  public get_project_users() {
    const project_users = readProjectUsers(store);
    let user_list: any[] = [];
    project_users.forEach((item: any) => {
      if (item.is_project_admin) {
        user_list.push(item.user);
      }
    });
    return unique(user_list).join(";");
  }
  drawline() {
    let total_data: any[] = [];
    for (let i in this.total_trend.total) {
      total_data.push({
        name: i,
        type: "line",

        data: this.total_trend.total[i],
      });
    }

    var chartDom = document.getElementById("total_memory") as HTMLElement;
    var myChart = echarts.init(chartDom);
    myChart.setOption({
      title: {
        text: "组件总内存【MB】版本变化趋势",
        x: "center",
        y: "top",
        textAlign: "left",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        orient: "horizontal",
        left: "center",
        top: " 420px",
        data: this.total_trend.scene_list,
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "13%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      animation: false,
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.total_trend.x_axis,
      },
      yAxis: {
        type: "value",
      },
      series: total_data,
    });
    var res_base64 = myChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.type = "total";
    // res.filename = "report" + type + ".png";
    res.filename =
      "report" +
      "total" +
      "_project" +
      this.localProject +
      "_report" +
      this.$route.query.report_id +
      ".png";
    this.resBase64.push(res);
    return myChart;
  }
  drawEachMemory(item: any, value: any) {
    let memorySeries = [];
    for (let i in value) {
      memorySeries.push({
        name: i,
        type: "bar",
        stack: "total",
        label: {
          show: true,
        },
        emphasis: {
          focus: "series",
        },
        data: value[i],
      });
    }

    var chartDom = document.getElementById("each_memory" + item) as HTMLElement;
    var myChart = echarts.init(chartDom);
    myChart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // Use axis to trigger tooltip
          type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
        },
      },
      title: {
        text: item + "场景—各组件内存(MB)版本变化趋势",
        x: "center",
        y: "top",
        textAlign: "left",
      },
      legend: {
        left: "center",
        top: " 425px",
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "13%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: this.memory_trend.x_axis,
      },
      animation: false,
      yAxis: {
        type: "value",
      },
      series: memorySeries,
    });
    var res_base64 = myChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.type = item;
    // res.filename = "report" + type + ".png";
    res.filename =
      "report" +
      item +
      "_project" +
      this.localProject +
      "_report" +
      this.$route.query.report_id +
      ".png";
    this.resBase64.push(res);
    return myChart;
  }

  public async mounted() {
    // this.formMail.addressee = this.get_project_users();
    await dispatchGetXhookReportList(store, { project: this.localProject });

    if (this.$route.query.report_id) {
      this.report_id = Number(this.$route.query.report_id);
    } else {
      this.report_id = this.xhook_reports[0] ? this.xhook_reports[0]?.id : 0;
    }
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    let report_name = (readXhookReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].cur_version;
    let report_time = (readXhookReportList(store) as any[])
      .filter((item: any) => item.id === this.report_id)[0]
      .test_time.replace("/", "")
      .replace("/", "");
    this.formMail.title =
      "【GR自动化】" +
      this.project_info.project_name +
      "自动化xhook测试报告-" +
      report_name +
      "-" +
      report_time;
    if (this.report_id) {
      await dispatchGetXhookReport(store, {
        project: this.localProject,
        report_id: this.report_id,
      });
      this.set_report();
      this.get_risk();
    }
    await this.drawline();
    for (let i in this.memory_trend.memory) {
      await this.drawEachMemory(i, this.memory_trend.memory[i]);
    }
    // await this.drawEachMemory();
  }
  // 获取当前项目基本信息
  public get project_info() {
    return readProjectDetail(store);
  }
  // 切换报告
  public async change_report() {
    this.loading = true;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    let report_name = (readXhookReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].cur_version;
    let report_time = (readXhookReportList(store) as any[])
      .filter((item: any) => item.id === this.report_id)[0]
      .test_time.replace("/", "")
      .replace("/", "");
    this.formMail.title =
      "【GR自动化】" +
      this.project_info.project_name +
      "自动化xhook测试报告-" +
      report_name +
      "-" +
      report_time;
    await dispatchGetXhookReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    this.set_report();
    this.get_risk();
    await this.drawline();
    for (let i in this.memory_trend.memory) {
      await this.drawEachMemory(i, this.memory_trend.memory[i]);
    }
    this.loading = false;
  }
  public set_report() {
    const report = readXhookReport(store).data;

    (this.test_info as any) = report?.test_info;
    (this.core_data as any) = report?.core_data;
    (this.total_trend as any) = report?.total_trend;
    (this.memory_data as any) = report?.memory_data;
    (this.memory_trend as any) = report?.memory_trend;
    (this.previous_version as any) = report?.previous_version;

    // console.log(this.test_info.data.cur_version)
  }
  // 发送报告
  public async save_report() {
    let upload_data: any;
    upload_data = {
      // project: Number(this.$route.query.project),
      project: Number(this.localProject),
      report_id: Number(this.report_id),
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
    };
    dispatchSendXhookReport(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  // 颜色判定
  public get_risk_color(com_risk: string) {
    if (com_risk === "高风险") {
      return "color: red;";
    } else if (com_risk === "中风险") {
      return "color: #FF6100;";
    } else {
      return "color: green;";
    }
  }
  public get_color(value: number | string) {
    if (typeof value === "number") {
      if (value < 0) {
        return "green";
      }
    } else if (typeof value === "string") {
      if (value.indexOf("-") !== -1) {
        return "green";
      } else if (value.indexOf("%") !== -1) {
        const value_number = Number(value.split("%")[0]);
        if (value_number >= 8) {
          return "pink";
        } else if (value_number > 5) {
          return "pink2";
        }
      }
    }
  }
  public get_risk() {
    let top: any[] = [];
    let mid: any[] = [];
    this.core_data.forEach((item) => {
      if (item.risk === "高风险") {
        top.push(1);
      } else if (item.risk === "中风险") {
        mid.push(1);
      }
    });
    if (top.length >= 1) {
      this.com_risk = "高风险";
    } else if (mid.length >= 1) {
      this.com_risk = "中风险";
    }
  }
}
